import useAppModernisation from "../../hooks/useAppModernisation";
import GuidelineNav from "../../components/GuidelineNav/GuidelineNav";
import GuidelineNavWeb from "../../components/GuidelineNav/GuidelineNavWeb";
import useScreenSize from "../../hooks/useScreenSize";

const GuidelineNavRouter = ({guidelineObj}) => {
  const { isAppMode, isWebModernisationEnabled } = useAppModernisation();
  const { isDesktop } = useScreenSize();

  if (isAppMode || !isDesktop) {
    return <GuidelineNav glObj={guidelineObj} />;
  }

  if (isWebModernisationEnabled) {
    return <GuidelineNavWeb glObj={guidelineObj} />;
  }
};

export default GuidelineNavRouter;